module.exports = __webpack_public_path__ + "static/media/Preset.2a7609ce.svg";